import { storeCreator } from '@/utils/store/store.utils';

import { ContributionActivity } from './types';

export interface ChangedContributionRecord extends ContributionActivity {
  isDeleted?: boolean;
  amountsError?: string;
  dateError?: string;
  taxYearError?: string;
}

interface State {
  changedContributionRecords: ChangedContributionRecord[];
  changeRecord: (record: ChangedContributionRecord) => void;
  resetChangedContributionRecords: () => void;
}

export const useChangedContributionRecordsStore = storeCreator<State>((set, get) => ({
  changedContributionRecords: [],

  changeRecord: (record: ChangedContributionRecord) => set((state) => {
    const { changedContributionRecords } = get();
    const updatedRecords = [
      ...changedContributionRecords.filter((item) => item?.recordId !== record?.recordId),
      record,
    ];

    return {
      ...state,
      changedContributionRecords: updatedRecords,
    };
  }),

  resetChangedContributionRecords: () => set((state) => ({ 
    ...state,
    changedContributionRecords: [],
  })),
}));
